// Size and colour of the MUI icon leading each item in the analysis detail
// header (type, study period, last modified, source cohort). Shared so the
// meta row and the cohort row beneath it stay visually identical.
export const HEADER_ICON_SX = { fontSize: 18, color: 'text.secondary' } as const;
